import regExps from '../utils/Regex/regex';

const countryCodesToIds = {
  uy: 101,
  ar: 102,
  pe: 105,
};

const countryCodesToNames = {
  uy: 'Uruguay',
  ar: 'Argentina',
  pe: 'Perú',
};

const countryCodesToCurrencySymbol = {
  uy: '$UY',
  ar: '$AR',
  pe: 'S/',
};

const countryCodesToCurrencySymbolWithDesc = {
  uy: 'Pesos Uruguayos ($UY)',
  ar: 'Pesos Argentinos ($AR)',
  pe: 'Soles Peruanos (S/)',
};

const getCurrentCountryCode = () => {
  const result = regExps.hostWithCountryRegex.exec(window.location.host?.toLowerCase() || '');
  if (result && result[1]) {
    const countryCode = result[1];
    return countryCode;
  }
  if (process.env.REACT_APP_DEFAULT_COUNTRY) {
    return process.env.REACT_APP_DEFAULT_COUNTRY;
  }
  throw new Error('No country detected!');
};

const getCurrentCountryId = () => {
  const countryCode = getCurrentCountryCode();
  return countryCodesToIds[countryCode];
};

const getCurrentCountryName = () => {
  const countryCode = getCurrentCountryCode();
  return countryCodesToNames[countryCode];
};

const getCurrencySymbol = () => {
  const countryCode = getCurrentCountryCode();
  return countryCodesToCurrencySymbol[countryCode];
};

const getCurrencySymbolWithDescription = () => {
  const countryCode = getCurrentCountryCode();
  return countryCodesToCurrencySymbolWithDesc[countryCode];
};

export default {
  getCurrentCountryCode,
  getCurrentCountryId,
  getCurrentCountryName,
  getCurrencySymbol,
  getCurrencySymbolWithDescription,
};
